import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CommonModule, LocationStrategy} from '@angular/common';
import {Field, LookupItemComponent} from "../../components/lookup-item";
import {Batch, BatchRpcService, StateService} from "@alpha/services";
import {MultiItemHoverComponent} from "../../components/multi-item-hover/multi-item-hover.component";
import {Helpers} from '../../components/helpers'
import {Router, RouterLink} from "@angular/router";
import {RecentLookupsComponent} from "../../components/recent-lookups/recent-lookups.component";
import {ZXingScannerModule} from "@zxing/ngx-scanner";
import {BarcodeFormat} from "@zxing/browser";

@Component({
  selector: 'view-lookup',
  standalone: true,
  imports: [CommonModule, LookupItemComponent, RouterLink, RecentLookupsComponent, ZXingScannerModule],
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.scss']
})
export class LookupViewComponent implements OnInit {

  debounced_search: Function;

  protected readonly window = window;
  allowedFormats = [
    BarcodeFormat.AZTEC,
    /** CODABAR 1D format. */
    BarcodeFormat.CODABAR,
    /** Code 39 1D format. */
    BarcodeFormat.CODE_39,
    /** Code 93 1D format. */
    BarcodeFormat.CODE_93,
    /** Code 128 1D format. */
    BarcodeFormat.CODE_128,
    /** Data Matrix 2D barcode format. */
    BarcodeFormat.DATA_MATRIX,
    /** EAN-8 1D format. */
    BarcodeFormat.EAN_8,
    /** EAN-13 1D format. */
    BarcodeFormat.EAN_13,
    /** ITF (Interleaved Two of Five) 1D format. */
    BarcodeFormat.ITF,
    /** MaxiCode 2D barcode format. */
    BarcodeFormat.MAXICODE,
    /** PDF417 format. */
    BarcodeFormat.PDF_417,
    /** QR Code 2D barcode format. */
    BarcodeFormat.QR_CODE,
    /** RSS 14 */
    BarcodeFormat.RSS_14,
    /** RSS EXPANDED */
    BarcodeFormat.RSS_EXPANDED,
    /** UPC-A 1D format. */
    BarcodeFormat.UPC_A,
    /** UPC-E 1D format. */
    BarcodeFormat.UPC_E,
    /** UPC/EAN extension format. Not a stand-alone format. */
    BarcodeFormat.UPC_EAN_EXTENSION
  ];
  batches: Batch[] = []
  fields: Field[] = []
  loading: boolean = false;
  barcode_modal:boolean = false;
  barcode_search_active:boolean = true;
  awb_bol_search_active:boolean = false;
  @ViewChild("input") lookupField: ElementRef | undefined;

  constructor(private state: StateService,private bs: BatchRpcService, private location: LocationStrategy) {
    this.fields.push({label: 'AWB/BOL #', identifier: 'awb_bol_number'})
    this.fields.push({label: 'ETA', identifier: 'estimated_date_arrival'})
    this.fields.push({label: 'FDA Registration #', identifier: 'fda_registration'})
    this.fields.push({label: 'Facility Address', identifier: 'facility_address'})
    this.fields.push({label: 'TLC', identifier: 'barcodes', component: MultiItemHoverComponent})
    this.fields.push({label: 'Order Numbers', identifier: 'order_number', component: MultiItemHoverComponent})
    this.debounced_search = Helpers.debounce((val: string) => this.search(val), 1000);

    this.state.lookupObservable.subscribe((lookup)=>{
      if(lookup.length >0){
        const input :any=this.lookupField?.nativeElement;
        input.value = lookup;
        this.dummyData();
        this.search(lookup);
      }
    })
  }

  toggleAwbBol(){
    this.awb_bol_search_active = true;
    this.barcode_search_active = false;
  }
  toggleBarcode(){
    if(this.barcode_search_active){
      this.barcode_modal = !this.barcode_modal;
      if(this.barcode_modal){
        this.barcode_search_active = false;
      }
    }
    this.barcode_search_active = true;
    this.awb_bol_search_active = false;
  }

  scan(lookup:any){
    lookup = lookup
      .replace(/-/g, '')
      .replace(/ /g, '');
    const input :any=this.lookupField?.nativeElement;
    input.value = lookup;
    this.search(lookup)
    this.barcode_modal = false;
  }
  dummyData() {
    this.loading = true;

    let data: any= {
      awb_bol_number: "...................",
      estimated_date_arrival:".............. ......",
      fda_registration:"....................",
      facility_address:"...... .... ....... ... ....... ....",
      barcodes:['....'],
      order_number:['....'],
    }

    this.batches = [data]

  }

  search(val: string) {
    if(this.barcode_search_active){
      this.bs.getBatchListByBarcode(val)
        .then(res => {
          this.batches = res;
          if (this.batches.length > 0){
            this.state.add_recent_lookup(val)
          }
          this.loading = false;
        })
        .catch(e =>{
          this.loading = false;
          console.error(e)
        });
    }
    if(this.awb_bol_search_active){
      this.bs.getBatchListByAwbBol(val)
        .then(res => {
          this.batches = res;
          if (this.batches.length > 0){
            this.state.add_recent_lookup(val)
          }
          this.loading = false;
        })
        .catch(e =>{
          this.loading = false;
          console.error(e)
        });
    }
  }

  async ngOnInit() {
    const state:any = this.location.getState();
    if(state && state.batches ){
      this.batches = state.batches;
    }
  }

  async onChange(evt: any) {
  }

}
